<template>
		<div id="preview_card">
			<p class="upload_title">Preview CSV File</p>
			<div id="preview_content">
				<table style="width: 100%;">
					<thead>
						<tr>
							<th>S/N</th>
							<th>ORDER ID</th>
							<th>AMOUNT</th>
							<th>DISCO</th>
							<th>METER NUMBER</th>
							<th>PAYMENT TYPE</th>
							<th>PHONE NUMBER</th>
							<th>VEND TYPE</th>
							<th>VERTICAL</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(row, rowKey) in payload"
							v-bind:key="'row-' + rowKey"
							class="table-row"
						>
							<td>
								<p
									class="preview_serial"
									:class="{ row_error: !row.isValid }"
								>
									{{ rowKey + 1 }}
								</p>
							</td>
							<td class="table_cell">
								<div class="input_wrapper">
									<input
										v-model="row.data['Order Id']"
										@input="onInput(row, rowKey)"
										class="preview_input"
										:class="{
											input_error: row.errors['Order Id'],
										}"
									/>
									<div
										v-if="row.errors['Order Id']"
										class="error-message"
									>
										{{ row.errors["Order Id"] }}
									</div>
								</div>
							</td>
							<td class="table_cell">
								<div class="input_wrapper">
									<input
										v-model="row.data['Amount']"
										@input="onInput(row, rowKey)"
										class="preview_input"
										:class="{
											input_error: row.errors['Amount'],
										}"
									/>
									<div
										v-if="row.errors['Amount']"
										class="error-message"
									>
										{{ row.errors["Amount"] }}
									</div>
								</div>
							</td>
							<td class="table_cell">
								<div class="input_wrapper">
									<input
										v-model="row.data['Disco']"
										@input="onInput(row, rowKey)"
										class="preview_input"
										:class="{
											input_error: row.errors['Disco'],
										}"
									/>
									<div
										v-if="row.errors['Disco']"
										class="error-message"
									>
										{{ row.errors["Disco"] }}
									</div>
								</div>
							</td>
							<td class="table_cell">
								<input
									v-model="row.data['Meter']"
									@input="onInput(row, rowKey)"
									class="preview_input"
									:class="{
										input_error: row.errors['Meter'],
									}"
								/>
								<div
									v-if="row.errors['Meter']"
									class="error-message"
								>
									{{ row.errors["Meter"] }}
								</div>
							</td>
							<td class="table_cell">
								<input
									v-model="row.data['Payment Type']"
									@input="onInput(row, rowKey)"
									class="preview_input"
									:class="{
										input_error: row.errors['Payment Type'],
									}"
								/>
								<div
									v-if="row.errors['Payment Type']"
									class="error-message"
								>
									{{ row.errors["Payment Type"] }}
								</div>
							</td>
							<td class="table_cell">
								<input
									v-model="row.data['Phone']"
									@input="onInput(row, rowKey)"
									class="preview_input"
									:class="{
										input_error: row.errors['Phone'],
									}"
								/>
								<div
									v-if="row.errors['Phone']"
									class="error-message"
								>
									{{ row.errors["Phone"] }}
								</div>
							</td>
							<td class="table_cell">
								<input
									v-model="row.data['Vend Type']"
									@input="onInput(row, rowKey)"
									class="preview_input"
									:class="{
										input_error: row.errors['Vend Type'],
									}"
								/>
								<div
									v-if="row.errors['Vend Type']"
									class="error-message"
								>
									{{ row.errors["Vend Type"] }}
								</div>
							</td>
							<td class="table_cell">
								<input
									v-model="row.data['Vertical']"
									@input="onInput(row, rowKey)"
									class="preview_input"
									:class="{
										input_error: row.errors['Vertical'],
									}"
								/>
								<div
									v-if="row.errors['Vertical']"
									class="error-message"
								>
									{{ row.errors["Vertical"] }}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div
				style="width: 100%; display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;"
			>
				<button
					@click="cancelUpload"
					class="primary-button"
					style="background: none; border: solid 1px black; color: black"
          v-if="!isProcessing"
				>
					Cancel
				</button>
				<button
					@click="submitValidatedPayload"
					v-if="canContinue"
					class="primary-button"
          :disabled="isProcessing"
          :class="{ 'processing-state': isProcessing }"
				>
					<span v-if="!isProcessing">Continue</span>
          <div v-else class="loader"></div>
				</button>
			</div>
		</div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Array,
      required: true,
    },
    canContinue: {
      type: Boolean,
      required: true,
    },
    isProcessing: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onInput(row, index) {
      this.$emit('row-input', row, index);
    },
    submitValidatedPayload() {
      this.$emit('submit');
    },
    cancelUpload() {
      this.$emit('cancel');
    },
  },
};
</script>
<style>

.loader {
	border: 4px solid #ffffff;
	border-top: 4px solid #67ad5b;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	animation: spin 2s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.primary-button:hover {
	color: #fff !important;
	text-decoration: none;
	cursor: pointer;
	opacity: 1;
}

#preview_card {
	width: 1000px;
	height: 700px;
	padding: 30px;
	box-sizing: border-box;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #fff;
	border: none;
	border-radius: 4px;
}

#preview_content {
	width: 940px;
	height: 640px;
	overflow-y: scroll;
	margin-bottom: 16px;
}

.preview_input {
	padding: 8px;
	border-width: 1px;
	border-radius: 4px;
	border-color: #ccc;
}

.input_error {
	border-color: #ff0000;
}

.row_error {
	padding: 8px;
	color: #fff;
	background: #ff0000;
	line-height: 14px;
	border: none;
	border-radius: 50%;
}

.preview_serial {
	text-align: center;
}

.error_message {
	color: #ff0000;
	font-size: 12px;
	margin-top: 2px;
	line-height: 1.2;
}

.input-wrapper {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

td {
	vertical-align: top;
	padding: 4px 8px;
}

.primary-button {
	background: #67ad5b;
	color: #ffffff;
	width: fit-content;
	font-size: 16px;
	padding: 12px 24px;
	margin: 16px 0px;
	border: none;
	border-radius: 4px;
	border: solid 1px #67ad5b;
	display: block;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
}

.primary-button a {
	display: block;
	height: 100%;
	color: #fff;
	text-decoration: none;
}

.primary-button:visited {
	color: #fff;
	text-decoration: none;
}

.primary-button:focus {
	color: #fff;
	text-decoration: none;
}

.processing-state {
  margin-left: auto;
  width: 150px
}
</style>
